module.exports = "img/element-icons/room/default_video.f29df7d.svg";